import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=29415b98&"
import script from "./Page404.vue?vue&type=script&lang=js&"
export * from "./Page404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29415b98')) {
      api.createRecord('29415b98', component.options)
    } else {
      api.reload('29415b98', component.options)
    }
    module.hot.accept("./Page404.vue?vue&type=template&id=29415b98&", function () {
      api.rerender('29415b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Page404.vue"
export default component.exports